/**
 * Fournisseur de carte utilisé par le widget plan-de-quartier.
 *
 * La règle reproduit celle de `widgets-core/widgets/map/map.js` : la carte Karto
 * (Map'ici / Bien'ici) est utilisée partout, sauf en espagnol, en portugais et en
 * catalan qui restent sur Google Maps. Les deux fichiers doivent rester alignés.
 *
 * Cette information sert à décider si la sidebar du plan de quartier doit être
 * affichée : la carte Karto embarque déjà recherche, itinéraires et POI, alors que
 * la carte Google a besoin de la sidebar pour filtrer les POI.
 */
const GOOGLE_MAP_LANGUAGES = ['es', 'pt', 'ca'];

export function isKartoMap(language) {
    return !GOOGLE_MAP_LANGUAGES.includes(language || 'fr');
}

/**
 * Langue à utiliser pour choisir le fournisseur de carte.
 *
 * C'est `payload.language` qui fait foi : c'est exactement la valeur que reçoit
 * `widgets-core` (`data.language`) pour choisir entre Karto et Google Maps. La
 * langue devinée par le mégawidget (query `?language=`, localStorage, locale i18n)
 * ne sert que de valeur de repli, avant l'arrivée du payload — s'en contenter
 * faisait disparaître la sidebar sur une carte Google dès que les deux
 * divergeaient (programme espagnol ou portugais ouvert sans `?language=`).
 */
export function mapLanguage(payload, fallbackLanguage) {
    return (payload && payload.language) || fallbackLanguage;
}

export default { isKartoMap, mapLanguage };



// WEBPACK FOOTER //
// ./src/utils/mapProvider.js